import React from "react"
import { BiPlusMedical } from "react-icons/bi"
import { type Props } from "./_types"
const IconPlus2: React.FC<Props> = ({ size = 15, color = "#fff" }): React.ReactElement => {
  return <BiPlusMedical size={size} color={color} />
}

export default IconPlus2
